module.exports = "pegasus/assets/color-icon-black.png";